<template>
    <div class="main main-padding tabs-data-details">
        <div class="top-area">
            <!--返回-->
            <div class="main-back">
                <div class="bank-back" v-on:click="gotoBack">
                    <img src="../../../assets/images/back.png"/>
                    <p class="click-text">返回</p>
                </div>
            </div>
            <!--产品类型下拉框-->
            <div class="pro-download">
                <span>学段:</span>
                <Select v-model="phase" style="width:200px" @on-change="onChange">
                    <Option v-for="item in stageList" :value="item.value" :key="item.value">{{ item.label }}
                    </Option>
                </Select>
            </div>
            <!--区域选择-->
            <!--<div class="area-select">-->
                <!--<area-select-->
                    <!--@query-table-data="queryTableData"-->
                <!--&gt;</area-select>-->
            <!--</div>-->
            <!--<Col :xs="2" :sm="2" :md="2" :lg="2" class="load-button">-->
                <!--<Button-->
                    <!--type="primary"-->
                    <!--@click.native="downloadProData()"-->
                <!--&gt;导出-->
                <!--</Button>-->
            <!--</Col>-->
        </div>
        <!--数据信息-->
        <card class="data-cloud-ive">
            <div class="details-card-header-area">
                <!--tab切换数据-->
                <div class="details-tab-data">
                    <span>学校列表</span>
                </div>
                <!--&lt;!&ndash;搜索框&ndash;&gt;-->
                <!--<div class="input-data">-->
                    <!--<Input-->
                        <!--v-model="keyWord"-->
                        <!--placeholder="支持学校名称关键字搜索"-->
                        <!--icon="ios-search"-->
                        <!--clearable-->
                        <!--@on-enter="handleSearch"-->
                    <!--&gt;-->
                        <!--<Button-->
                            <!--slot="append"-->
                            <!--icon="ios-search"-->
                            <!--class="search-input-button"-->
                            <!--@click="handleSearch"-->
                            <!--type="primary"-->
                        <!--&gt;</Button>-->
                    <!--</Input>-->
                <!--</div>-->
            </div>
            <div>
                <!--教师使用产品详情-->
                <div class="table-wrapper-data">
                    <Table :columns="schoolColumn" :data="schoolList"></Table>
                </div>
                <!--分页,大屏重复绑定情况下不显示-->
                <div class="laypage_main">
                    <Page
                        :total="total"
                        :current="page"
                        :page-size="limit"
                        @on-change="handleCurrentChange"
                        v-show="total && pageCount>1"
                        show-total
                    />
                </div>
            </div>
        </card>
    </div>
</template>
<script>
    import {getSchoolDetail} from "../../../service/api.js";

    const AreaSelect = () => import("../../../components/AreaSelect");//引入地区选择组件

    export default {
        name: "wisdom-class-static",
        components: {
            AreaSelect
        },
        data () {
            return {
                keyWord: "",
                page: 1,
                limit: 10,
                total: 0,
                pageCount: 0,
                phase: this.$route.query.phase.toString(),
                schoolColumn: [
                    {
                        title: "序号",
                        key: "rowNum",
                        align: "center"
                    },
                    {
                        title: "学校Id",
                        key: "id",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            title: "点击查看学校详情",
                                            href: "javascript:void(0);"
                                        },
                                        style: {
                                            color: "bule",
                                            fontSize: "12px"
                                        },
                                        on: {
                                            click: () => {
                                                this.lookSchoolDetails(params.row);
                                            }
                                        }
                                    },
                                    params.row.id
                                )
                            ]);
                        }
                    },
                    {
                        title: "学段",
                        key: "phase",
                        align: "center"
                    },
                    {
                        title: "域名",
                        key: "domain_name",
                        align: "center"
                    },
                    // {
                    //     title: "省",
                    //     key: "province_name",
                    //     align: "center"
                    // },
                    // {
                    //     title: "市",
                    //     key: "city_name",
                    //     align: "center"
                    // },
                    // {
                    //     title: "县",
                    //     key: "district_name",
                    //     align: "center"
                    // },
                    {
                        title: "创建时间",
                        key: "gmt_create",
                        align: "center"
                    },
                    {
                        title: "学校用户数（人）",
                        key: "count",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            title: "点击查看用户列表",
                                            href: "javascript:void(0);"
                                        },
                                        style: {
                                            color: "bule",
                                            fontSize: "12px"
                                        },
                                        on: {
                                            click: () => {
                                                this.lookSchoolTeacherInfo(params.row);
                                            }
                                        }
                                    },
                                    params.row.count
                                )
                            ]);
                        }
                    }
                ],
                stageList: [
                    {
                        value: "0",
                        label: '全部'
                    },
                    {
                        value: "1",
                        label: '小学'
                    },
                    {
                        value: "2",
                        label: '初中'
                    },
                    {
                        value: "3",
                        label: '高中'
                    }
                ],
                filters: {
                    provinceId: "", //省
                    cityId: "", //市
                    districtId: "" //区，县
                },
                schoolList: []//学校列表
            };
        },
        methods: {
            /**
             * 导出产品信息
             */
            downloadProData () {
                let phaseNumber= this.phase==="0"?'':this.phase;
                let url =
                    process.env.VUE_APP_APIURL +
                    "/website/wisdom/exportSchoolListToExcel?phaseNumber=" +
                    phaseNumber +
                    "&provinceid=" +
                    this.filters.provinceId +
                    "&cityid=" +
                    this.filters.cityId +
                    "&districtid=" +
                    this.filters.districtId +
                    "&keyWord=" +
                    this.keyWord +
                    "&page=" +
                    this.page +
                    "&limit=" +
                    this.limit;
                let iframe = document.createElement("iframe");
                iframe.style.display = "none";
                iframe.src = url;
                iframe.onload = function () {
                    document.body.removeChild(iframe);
                };
                document.body.appendChild(iframe);
            },
            /**
             * 返回上一页
             */
            gotoBack () {
                this.$router.push({
                    name: "wisdomClassMain",
                });
            },
            /**
             *点击切换产品类型下拉框
             */
            onChange (val) {
                this.phase = val;
                this.total = 0;
                this.page = 1;
                this.schoolList = [];
                //根据学段获取学校列表
                this.querySchoolDetail();
            },
            /**
             *搜索关键字
             */
            handleSearch () {
                this.total = 0;
                this.page = 1;
                //根据学段获取学校列表
                this.querySchoolDetail();
            },
            /**
             *翻页
             */
            handleCurrentChange (val) {
                this.page = val;
                //根据学段获取学校列表
                this.querySchoolDetail();
            },
            /**
             * 选择省市县查询
             */
            queryTableData (provinceId, cityId, districtId) {
                let _this = this;
                _this.filters.provinceId = provinceId;
                _this.filters.cityId = cityId;
                _this.filters.districtId = districtId;
                _this.total = 0;
                _this.page = 1;
                //根据学段获取学校列表
                _this.querySchoolDetail();
            },
            /**
             *根据学段获取学校列表
             */
            async querySchoolDetail () {
                let _this = this;
                let params = {
                    provinceId: _this.filters.provinceId,
                    cityId: _this.filters.cityId,
                    districtId: _this.filters.districtId,
                    phase: _this.phase === "0" ? '' : _this.phase,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await getSchoolDetail(params)
                    .then(function (data) {
                        if (Object.keys(data).length !== 0) {
                            _this.schoolList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 根据学校查询用户列表
             */
            lookSchoolTeacherInfo (row) {
                this.$router.push({
                    name: "schoolTeacherInfo",
                    query: {
                        schoolId: row.id,
                        phase: this.phase
                    }
                });
            },
            /**
             * 查看学校数据详情
             */
            lookSchoolDetails (row) {
                let routeData = this.$router.resolve({
                    name: "wisdomMain",
                    query: {
                        schoolId: row.id,
                        // schoolName: row.school_name,
                        phase: this.phase
                    }
                });
                window.open(routeData.href, '_blank');
            }
        },
        mounted () {
            this.$nextTick(() => {
                //修改公共属性学校名称
                this.$store.commit("SET_TOPHEADERNAME", '一起智慧课堂');
            });
            // 根据学段获取学校列表
            this.querySchoolDetail();
        }
    };
</script>
<style lang="scss" scoped>
    @import "../../../style/home";
    @import "../../../style/dataDetails";

    .pro-download {
        margin-right: 15px;
    }
</style>
<style lang="scss">
    .tabs-data-details {
        .ivu-input-group {
            width: 300px;
            float: right;
            top: 0;
        }

        .ivu-card-body {
            padding: 16px;
        }

        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 355px;
        }

        .ivu-row {
            margin-top: 0 !important;
        }

        .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
            color: #fff;
            background: #57a3f3;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-btn-icon-only {
            border-radius: 0 4px 4px 0;
        }

        .ivu-input-icon-clear {
            margin-right: 45px;
        }

        .ivu-table {
            font-size: 14px;
        }

        .ivu-table-tip {
            overflow-x: hidden;
        }

        .ivu-tabs-nav {
            font-size: 14px;
        }

        .ivu-table-overflowX {
            overflow-x: hidden;
        }

    }
</style>

